import { formatAppDateTime } from "./appTimeFormat";

export const formatOutcomeLabel = (outcome) => {
  const parts = [outcome?.section, outcome?.subSection, outcome?.key].filter(
    (part) => part != null && String(part).trim() !== ""
  );
  return parts.join(" · ") || "Outcome";
};

export const formatKickoffUnix = (unix) => {
  if (unix == null || !Number.isFinite(Number(unix))) return "Schedule pending";
  return formatAppDateTime(Number(unix) * 1000);
};

export const formatOddsValue = (value) => {
  if (value == null || typeof value !== "number" || Number.isNaN(value)) return "—";
  return Number(value).toFixed(2);
};

export const buildOperatorAttentionFlags = ({
  operatorHealth,
  closingSoon = 0,
  suspendedFixtures = 0,
}) => {
  if (!operatorHealth) return { showAlerts: false, needsAttention: false };

  const showAlerts =
    operatorHealth.autoPauseImminent ||
    (operatorHealth.atMinimumBettablePool && !operatorHealth.autoPauseImminent) ||
    (operatorHealth.lowBettableHeadroom &&
      !operatorHealth.autoPauseImminent &&
      !operatorHealth.atMinimumBettablePool) ||
    operatorHealth.fixturesNeedingOdds > 0 ||
    closingSoon > 0 ||
    suspendedFixtures > 0;

  const needsAttention =
    suspendedFixtures > 0 ||
    closingSoon > 0 ||
    operatorHealth.fixturesNeedingOdds > 0;

  return { showAlerts, needsAttention };
};

export const riskDeskIsClear = ({
  showAlerts,
  openFixtureBoard = [],
  topByLiability = [],
  topByLegCount = [],
}) =>
  !showAlerts &&
  openFixtureBoard.length === 0 &&
  topByLiability.length === 0 &&
  topByLegCount.length === 0;
